<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '软件'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="85px" :rules="rules">
      <el-form-item label="软件名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入软件名称"></el-input>
      </el-form-item>
      <el-form-item label="客户类型" prop="Type">
        <el-select v-model="item.Type" clearable placeholder="请选择分类">
          <el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting || !item.Name">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { max: 100, message: '名称不能超过100个字', trigger: 'blur' },
        ],
        Type: [
          { required: true, message: '分类不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
      type: [
        {
          value: 1,
          label: '类型1',
        },
        {
          value: 2,
          label: '类型2',
        },
        {
          value: 3,
          label: '类型3',
        },
      ],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
      this.$refs.file.value = '';
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit('input', this.item);
        this.item.Main = 2;
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `software/${itemData.ID}` : 'software',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '编辑成功' : '新增成功');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
